export enum StudentInactivationReason {
  DELINQUENCY = 'delinquency',
  COST_REDUCTION = 'cost_reduction',
  NOT_TRAINING = 'not_training',
  DID_NOT_ADAPT_TO_FORMAT = 'did_not_adapt_to_format',
  PREFERS_PERSONAL = 'prefers_personal',
  MOVED_TO_GYM_WITH_PERSONAL = 'moved_to_gym_with_personal',
  HEALTH = 'health',
  CONSULTANCY_DISSATISFACTION = 'consultancy_dissatisfaction',
  PLAN_CHANGE = 'plan_change',
  OTHERS = 'others',
}

export const STUDENT_INACTIVATION_REASON_OPTIONS = [
  { value: StudentInactivationReason.DELINQUENCY, label: 'Inadimplência' },
  { value: StudentInactivationReason.COST_REDUCTION, label: 'Redução de custo' },
  { value: StudentInactivationReason.NOT_TRAINING, label: 'Não tem treinado' },
  { value: StudentInactivationReason.DID_NOT_ADAPT_TO_FORMAT, label: 'Não se adaptou ao formato' },
  { value: StudentInactivationReason.PREFERS_PERSONAL, label: 'Prefere personal' },
  {
    value: StudentInactivationReason.MOVED_TO_GYM_WITH_PERSONAL,
    label: 'Migrou para academia com personal',
  },
  {
    value: StudentInactivationReason.HEALTH,
    label: 'Saúde (lesão, doença, cirurgia ou gestação/pós-parto)',
  },
  {
    value: StudentInactivationReason.CONSULTANCY_DISSATISFACTION,
    label: 'Insatisfação com a consultoria',
  },
  { value: StudentInactivationReason.PLAN_CHANGE, label: 'Mudança de plano' },
  { value: StudentInactivationReason.OTHERS, label: 'Outros' },
] as const;

const STUDENT_INACTIVATION_REASON_LABELS = Object.fromEntries(
  STUDENT_INACTIVATION_REASON_OPTIONS.map((option) => [option.value, option.label]),
) as Record<StudentInactivationReason, string>;

export const STUDENT_INACTIVATION_REASON_VALUES = new Set<string>(
  STUDENT_INACTIVATION_REASON_OPTIONS.map((option) => option.value),
);

export function getStudentInactivationReasonLabel(
  value: string | null | undefined,
): string {
  if (!value) {
    return '—';
  }

  return STUDENT_INACTIVATION_REASON_LABELS[value as StudentInactivationReason] ?? value;
}

export function isStudentInactivationReason(
  value: string,
): value is StudentInactivationReason {
  return STUDENT_INACTIVATION_REASON_VALUES.has(value);
}
